import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import DiaryLogGroup from "../../../Diaries/Logs/logGroup";
import ListingComponent from "../../../../components/ListingComponent";
import { getDiaryLogs } from "../../actions";

// Helpers
const groupByDate = (items) =>
    items.reduce((acc, item) => {
        const [date, time] = (item.NonFormatedUpdatedDate ?? '').split("at");
        const lastId = item.TodoUpdates?.at(-1)?.Id ?? 0;
        if (!acc[date]) acc[date] = [];
        acc[date].push({ id: lastId, date, time, data: item });
        return acc;
    }, {});

const NoDataFound = () => (
    <div data-test="No Data" className="noDataFound noFoundDiary label">
        No Data Found
    </div>
);

const NOOP = () => false;

const Logs = () => {
    const dispatch = useDispatch();

    const { listingData, selectedDiary } = useSelector(state => state.diaries.listing);
    const diaryDetails = listingData?.data?.find(d => d.todo_id === selectedDiary) ?? null;    
    
    // const { diaryLogs, selectedDiary, activeTab, isRightLoading } = useSelector(
    //     state => ({
    //         diaryLogs:      state.diaries.listing.logs,
    //         selectedDiary:  state.diaries.listing.selectedDiary,
    //         activeTab:      state.diaries.listing.activeTab,
    //         isRightLoading: state.diaries.listing.isRightLoading,
    //     }),
    //     shallowEqual
    // );

    // useEffect(() => {
    //     if (activeTab === 1 && selectedDiary) {
    //         // dispatch(getDiaryLogs({ id: selectedDiary }));
    //     }
    // }, [selectedDiary, activeTab, dispatch]);

    // // Build grouped list props only when logs change
    // const listContent = useMemo(() => {
    //     if (!diaryLogs.todoLogs?.length) return null;

    //     const grouped = groupByDate(diaryLogs.todoLogs);
    //     return {
    //         data:            Object.keys(grouped).map(key => ({ key, data: grouped[key] })),
    //         cellTemplate:    DiaryLogGroup,
    //         onScrollHandler: NOOP,
    //         onItemClick:     NOOP,
    //         type:            "ul",
    //         classname:       "scrollArea logDiaryList",
    //         selectedId:      "",
    //     };
    // }, [diaryLogs.todoLogs]);

    return (
        <div data-test="Logs" className="logMainContainer detailMainContainer">
            {!diaryDetails?.logs && <NoDataFound />}
            {/* <ListingComponent logsData={diaryDetails?.logs} /> */}
        </div>
    );
};

export default Logs;